import { RolesMap } from '@/models/user'
import { RouteRecordRaw } from 'vue-router'
import SettingsModule from './SettingsModule.vue'
import GeneralSettings from './views/GeneralSettings.vue'
import EmailSettings from './Email/views/EmailSettings.vue'
import UserSettings from './User/views/UserSettings.vue'
import EditUser from './User/views/EditUser.vue'
import QuickBooksSettings from './Quickbooks/views/QuickBooksSettings.vue'
import HubspotSettings from './Hubspot/views/HubspotSettings.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/settings',
    component: SettingsModule,
    meta: { authorize: true },
    children: [
      {
        path: 'general',
        name: 'GeneralSettings',
        component: GeneralSettings,
        meta: { authorize: [RolesMap.ADMIN_ROLE] }
      },
      {
        path: 'email',
        name: 'EmailSettings',
        component: EmailSettings,
        meta: { authorize: [RolesMap.ADMIN_ROLE] }
      },
      {
        path: 'iam',
        name: 'UserSettings',
        component: UserSettings,
        meta: { authorize: [RolesMap.ADMIN_ROLE] }
      },
      {
        path: 'edituser/:uid',
        name: 'EditUser',
        component: EditUser,
        meta: { authorize: [RolesMap.ADMIN_ROLE] }
      },
      {
        path: 'qbo',
        name: 'QuickBooksSettings',
        component: QuickBooksSettings,
        meta: { authorize: [RolesMap.ADMIN_ROLE] }
      },
      {
        path: 'hubspot',
        name: 'HubspotSettings',
        component: HubspotSettings,
        meta: { authorize: [RolesMap.ADMIN_ROLE] }
      }
    ]
  }
]

export default routes
